import './text.scss';

import { Slot } from '@radix-ui/react-slot';

import { cn } from '../../utils/helpers';

export enum Variants {
  Heading = 'heading',
  Body = 'body',
  Label = 'label',
}

export enum Sizes {
  XSmall = 'xs',
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
  XLarge = 'xl',
}

export enum Prominence {
  Subtle = 'subtle',
  Mild = 'mild',
  Moderate = 'moderate',
  Potent = 'potent',
  Amplified = 'amplified',
}

export enum Purposes {
  Positive = 'positive',
  Neutral = 'neutral',
  Warning = 'warning',
  Negative = 'negative',
  Disabled = 'disabled',
  Invert = 'invert',
}

export type TextProps = React.PropsWithChildren<{
  variant?: Variants;
  size?: Sizes;
  prominence?: Prominence; // When using the Text component, prominence only applies to font-weight, not color/purpose
  purpose?: Purposes;
  asChild?: boolean;
}>;

/**
 * Text component that is mainly used for applying typopgraphy
 * in highly dynamic contexts such as granular CMS page building.
 *
 * @TODO Could use some feedback on the above description...
 */
export const Text: React.FC<TextProps> = ({
  variant = Variants.Body,
  size,
  prominence,
  purpose,
  asChild,
  ...props
}: TextProps) => {
  const Comp = asChild ? Slot : 'span';
  return (
    <Comp
      {...props}
      // Overwrite className and style to prevent anyone altering styles.
      className={cn({
        [`${variant}`]: variant && !size,
        [`${variant}-${size}`]: variant && size,
        [`${variant}-${purpose}`]: variant && purpose,
        [`${variant}-${prominence}`]: variant && prominence,
      })}
      style={undefined}
    />
  );
};
